import { inferRouteObject } from 'react-router-typed-object';
import { z } from 'zod';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles, and, not, or } from '@/js/libs/use-auth';

import { POST_CRM, ContactFormSearchParams } from 'src/scenes/PostCRM';
import Status from 'src/scenes/Status';

const index = true;

export const postCrmRouteObject = inferRouteObject({
  path: 'post-crm',
  element: (
    <PrivateRoute
      roles={and(or(Roles.ADMIN, Roles.MANAGE_ACCOUNTS, Roles.POSTADMANAGER), not(Roles.POSTNETZ_BRANCH_USER))}
      noAccessComponent={Status.NotFound}
    />
  ),
  children: [
    {
      Component: POST_CRM.Helmet,
      children: [
        {
          path: 'accounts',
          children: [
            { index, Component: POST_CRM.Accounts.AccountsList },
            { path: 'create', Component: POST_CRM.AccountFormRenderer },
            {
              path: ':accountId',
              children: [{ index, Component: POST_CRM.Accounts.AccountOverview }],
            },
            {
              path: 'edit/:accountId',
              Component: POST_CRM.AccountFormRenderer,
            },
          ],
        },
        {
          element: <PrivateRoute roles={or(Roles.ADMIN, Roles.MANAGE_ACCOUNTS, Roles.POSTADMANAGER)} noAccessComponent={Status.NotFound} />,
          children: [
            {
              path: 'contacts',
              children: [
                { index, Component: POST_CRM.Contacts },
                {
                  path: 'create',
                  Component: POST_CRM.ContactForm,
                  searchParams: z.object({
                    [ContactFormSearchParams.ACCOUNT_ID]: z.string().optional(),
                    [ContactFormSearchParams.REDIRECT_TO]: z.string().optional(),
                  }).parse,
                },
                {
                  path: 'edit/:contactId',
                  Component: POST_CRM.ContactForm,
                  searchParams: z.object({
                    [ContactFormSearchParams.ACCOUNT_ID]: z.string().optional(),
                    [ContactFormSearchParams.REDIRECT_TO]: z.string().optional(),
                  }).parse,
                },
                {
                  path: 'history',
                  children: [
                    { index, element: <Navigate to='contacts' replace /> },
                    { path: ':contactId', Component: POST_CRM.ContactHistory },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
